import { mailtoRegExp, telRegExp } from '@elfsight/lib-utils';

const urlRegExp =
  /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/|\/\/)?[a-zA-Z0-9\u0080-\uFFFF]+([-.][a-zA-Z0-9\u0080-\uFFFF]*)*\.[a-zA-Z\u0080-\uFFFF]{2,10}(:[0-9]{1,5})?(\/.*)?(\\?.*)?$/;

type LinkType = 'email' | 'url' | 'phone';

export const validateLink = (type: LinkType, value: string) => {
  const valid = {
    url: () => urlRegExp.test(value),
    email: () => mailtoRegExp.test(value),
    phone: () => telRegExp.test(value)
  }[type];

  return Boolean(valid());
};
